import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { Logger } from './core/service/logger.service';
import { ThemeService } from './core/service/theme.service';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  template: ` <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  title = environment.configuracaoThema.name;

  constructor(
    private titleService: Title,
    private config: PrimeNGConfig,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.atualizarTitulo();
    this.themeService.applyTheme(this.renderer);

    this.translateService.setDefaultLang('pt');
    this.translate('pt');

    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService
      .get('primeng')
      .subscribe((res) => this.config.setTranslation(res));
  }

  private atualizarTitulo() {
    this.titleService.setTitle(this.title);
  }
}
